// extracted by mini-css-extract-plugin
export default {"cell":"Rows_cell__9kALK","icon":"Rows_icon__cn2sn","linkIcon":"Rows_linkIcon__y62dq","badge":"Rows_badge__8UyDH","row":"Rows_row__BCHxq"};